module.exports = __webpack_public_path__ + "512c14e3e3399e612d05ae8bc0a83870.svg";